import { action } from '@ember/object';

import type { ImageCropData } from 'webapp-types';
import { ReportFragmentAction } from 'webapp/enums/enums';

import type { ReportFragmentActionData } from 'webapp/components/reports/editor-base';
import ReportsEditorEditableImageComponent from 'webapp/components/reports/editor/editable-image';
import type { Args as BaseArgs } from 'webapp/components/reports/viewer/fragment/image';
import ReportsViewerFragmentImageComponent from 'webapp/components/reports/viewer/fragment/image';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args extends BaseArgs {
	onFragmentChange: (
		fragment: ReportSlideFragment,
		action: ReportFragmentAction,
		data?: ReportFragmentActionData,
	) => Promise<unknown>;
}

export default class ReportsEditorFragmentImageComponent extends ReportsViewerFragmentImageComponent<Args> {
	@action
	changeImage(imageUrl: string, imageOriginalUrl: string, imageCrop: ImageCropData | null): void {
		const fragment = this.args.model;
		fragment.updateImage(imageUrl, imageOriginalUrl, imageCrop);
		void this.args.onFragmentChange(fragment, ReportFragmentAction.CONTENT);
	}
	<template>
		<div class="fragment fragment--image">
			<ReportsEditorEditableImageComponent @model={{@model}} @onChange={{this.changeImage}} />
		</div>
	</template>
}
